import { UserState } from '../types.ts';

// Безопасное получение Telegram WebApp с обработкой ошибок
const getTelegramWebApp = () => {
  try {
    return window.Telegram?.WebApp;
  } catch (error) {
    console.warn('⚠️ Telegram WebApp not available:', error);
    return null;
  }
};

const tg = getTelegramWebApp();

export const initTelegramApp = () => {
  try {
    if (tg) {
      // Проверяем наличие методов перед вызовом
      if (typeof tg.ready === 'function') {
        tg.ready();
      }
      if (typeof tg.expand === 'function') {
        tg.expand(); // Try to take full height
      }
    }
  } catch (error) {
    console.warn('⚠️ Error initializing Telegram WebApp:', error);
    // Продолжаем работу без Telegram функций
  }
};

export const getTelegramUser = () => {
  try {
    if (tg?.initDataUnsafe?.user) {
      return tg.initDataUnsafe.user;
    }
  } catch (error) {
    console.warn('⚠️ Error getting Telegram user:', error);
  }
  return null;
};

export const setBackButton = (isVisible: boolean, onClick?: () => void) => {
  try {
    if (!tg?.BackButton) return;

    if (isVisible) {
      if (typeof tg.BackButton.show === 'function') {
        tg.BackButton.show();
      }
      if (onClick) {
        // Remove old listeners to avoid duplicates (simple approach)
        if (typeof tg.BackButton.offClick === 'function') {
          tg.BackButton.offClick(onClick); 
        }
        if (typeof tg.BackButton.onClick === 'function') {
          tg.BackButton.onClick(onClick);
        }
      }
    } else {
      if (typeof tg.BackButton.hide === 'function') {
        tg.BackButton.hide();
      }
      if (onClick && typeof tg.BackButton.offClick === 'function') {
        tg.BackButton.offClick(onClick);
      }
    }
  } catch (error) {
    console.warn('⚠️ Error setting back button:', error);
  }
};

export const hapticFeedback = (type: 'success' | 'light' | 'medium' | 'heavy' | 'error') => {
    try {
        if (!tg?.HapticFeedback) return;
        
        if (type === 'success' || type === 'error') {
            if (typeof tg.HapticFeedback.notificationOccurred === 'function') {
                tg.HapticFeedback.notificationOccurred(type);
            }
        } else {
            if (typeof tg.HapticFeedback.impactOccurred === 'function') {
                tg.HapticFeedback.impactOccurred(type);
            }
        }
    } catch (error) {
        console.warn('⚠️ Error with haptic feedback:', error);
        // Игнорируем ошибки haptic feedback - это не критично
    }
};

// Mock function to simulate payment in development or trigger real invoice
export const buyPremium = (callback: (success: boolean) => void) => {
    if (!tg) {
        // Browser dev mode fallback
        const confirm = window.confirm("Симуляция оплаты: Купить Sobu Gold за 50 звезд?");
        callback(confirm);
        return;
    }

    // In a real scenario, you fetch an invoice link from your backend
    // const invoiceUrl = await fetch('/api/create-invoice').then(res => res.json());
    // tg.openInvoice(invoiceUrl, (status) => { ... });

    // Since we don't have a backend endpoint connected to BotFather yet,
    // we simulate the UI flow or show a popup.
    
    tg.showPopup({
        title: 'Sobu Gold',
        message: 'Оплата через Telegram Stars пока в тестовом режиме. Активировать бесплатно для теста?',
        buttons: [
            {id: 'ok', type: 'default', text: 'Активировать'},
            {id: 'cancel', type: 'cancel', text: 'Отмена'}
        ]
    }, (btnId) => {
        if (btnId === 'ok') {
            callback(true);
        } else {
            callback(false);
        }
    });
};